import { type IProductHeaderMedicineInfo, Icon } from '~/index'
import * as C from './product-header-medicine-info.styles'

export function ProductHeaderMedicineInfo({
  brand,
  measurament,
  hasIcon,
  brandIcon,
  measuramentIcon,
  activeIngredient,
  activeIngredientIcon,
  testID,
}: IProductHeaderMedicineInfo) {
  return (
    <C.MedicineInfo hasIcon={hasIcon} testID={testID}>
      {hasIcon && <Icon size="tiny" symbol={brandIcon} />}
      <C.MedicineInfoText numberOfLines={1} hasIcon={hasIcon}>
        {brand}
      </C.MedicineInfoText>
      {hasIcon ? (
        <Icon size="tiny" symbol={measuramentIcon} />
      ) : (
        <C.MedicineInfoMark>•</C.MedicineInfoMark>
      )}
      <C.MedicineInfoText numberOfLines={1} hasIcon={hasIcon}>
        {measurament}
      </C.MedicineInfoText>
      {hasIcon ? (
        <Icon size="tiny" symbol={activeIngredientIcon} />
      ) : (
        <C.MedicineInfoMark>•</C.MedicineInfoMark>
      )}
      <C.MedicineInfoText numberOfLines={1} hasIcon={hasIcon}>
        {activeIngredient}
      </C.MedicineInfoText>
    </C.MedicineInfo>
  )
}
